import React, { useState } from 'react';
import { useNavigate, Link } from "react-router-dom";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReCAPTCHA from "react-google-recaptcha";
import Loader from "./components/loader"
import URLBASE from "../api/urlRegister"
import '../App.css';


const EnviarEmail = () => {
	
	const navigate = useNavigate();
	
	const notificationError = message => toast.error(message);
	const notificationSuccess = message => toast.success(message);
	
	const [email, setEmail] = useState()
	const [loading, setLoading] = useState(false)
	const [recaptchaIsOk, setRecaptchaIsOk] = useState(false)
	
	async function postEnviarEmailForm(e){
		e.preventDefault();	
		const urlPost = URLBASE + "/informar-email"
		try{
			if(recaptchaIsOk){
				setLoading(true)
				const response = await fetch(urlPost, {
							method: 'POST',
							headers: {
							  'Accept': 'application/json',
							  'Content-Type': 'application/json',
							  'Access-Control-Allow-Origin': 'POST',
							},
							body: JSON.stringify({
								email: email
							})
						  });
						  const content = await response.json();
						  if(content.status === "True"){	
							notificationSuccess('Código enviado.');
							navigate("/recuperar-senha", {state: {email: email}}) //redirecionar e passar o e-mail pra essa rota
						  }else{
							notificationError(content.mensagem);
						  }
			}else{
				notificationError('Por favor, resolva o captcha.');
			}
		}catch(error){
			notificationError('Um erro interno ocorreu.');
		}finally{
			setLoading(false)
		}
	}
	
	
	const captchaVerify = value => setRecaptchaIsOk(value);	
	
	return (
	

					<div id="row-informar-email" className="row">
						<div className="col-sm coluna-lateral"></div>
						<div className="col-lg-4 custom-col">
						<div id="informar-email" className="card shadow-sm rounded">					
						
							<center><p>Você receberá um código de confirmação em seu e-mail cadastrado. Por favor, confirme o e-mail cadastrado</p></center>
		
							<form style={{marginTop: "10px"}} onSubmit={postEnviarEmailForm}>
							  
							  <input placeholder="E-mail cadastrado" id="email" type="email" required name="email" className="form-control shadow-none" value={email} onChange={(e) => setEmail(e.target.value)} />
							  
							  <div id="recaptcha">
									<div style={{display: "flex", justifyContent: "center"}}>
										<ReCAPTCHA
											sitekey="6Lc3s-wfAAAAAA2JO1qcP7JYk8wbVjt1eJykuch4"
											onChange={captchaVerify}
										 />
									</div>								  
							  </div>
							  
							  <button id="btn-enviar-email" className="btn shadow-none">{loading ? <Loader small={true} color={"#ffffff"} /> : 'Enviar'}</button><br/>	
								
							  
							</form>

							<center><small><Link to="/">Voltar</Link></small></center>
					
											
						</div>
						</div>
						<div className="col-sm coluna-lateral"></div>
					</div>

	
	)
}
	

export default EnviarEmail;
